import { render, staticRenderFns } from "./cModalTogglePsicotropico.vue?vue&type=template&id=55a1499c"
import script from "./cModalTogglePsicotropico.vue?vue&type=script&lang=js"
export * from "./cModalTogglePsicotropico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports